import { HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse, HttpInterceptor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { DialogInfoComponent } from 'src/app/components/shared/dialog-info/dialog-info.component';
import { AuthService } from '../_services/auth.service';
import { SpinnerOverlayService } from '../_services/spinner.overlay.service';
import { NO_RETRY } from './http-context';

@Injectable()
export class ErrorIntercept implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private spinnerService: SpinnerOverlayService,
    private dialog: MatDialog
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      retry(request.method === 'GET' && !request.context.get(NO_RETRY) ? 1 : 0),
      catchError((error: HttpErrorResponse) => {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // server-side error — prefer the response body (e.g. FluentValidation messages
          // [{ propertyName, errorMessage }], ProblemDetails, or a plain string) so callers can show a
          // meaningful message instead of the generic HttpErrorResponse one.
          const body: any = error.error;
          if (Array.isArray(body)) {
            // one message per line (multiple validation failures)
            errorMessage = body
              .map((e: any) => e?.errorMessage || e?.ErrorMessage)
              .filter(Boolean)
              .join('\n');
          } else if (typeof body === 'string' && body) {
            errorMessage = body;
          } else if (body && (body.title || body.message || body.detail)) {
            errorMessage = body.title || body.message || body.detail;
          }
          if (!errorMessage) {
            errorMessage = `Error Status: ${error.status}\nMessage: ${error.message}`;
          }
        }

        // 401 = l'API refuse la clé de session (absente, expirée, droit retiré) : il n'y a plus rien à
        // faire dans l'application. Un refus portant sur une ressource précise sort en 403, pas en 401,
        // et ne doit surtout pas déconnecter.
        if (error.status === 401 && this.authService.userValue?.key) {
          this.spinnerService.hide();
          this.authService.logout();
        }

        if (error.status === 403) {
          this.spinnerService.hide();
          this.showForbidden(errorMessage);
        }

        return throwError(errorMessage);
      })
    );
  }

  // Le serveur renseigne le motif du refus dans le corps de la réponse ; il est déjà rédigé pour
  // l'utilisateur. Une seule boîte à la fois : plusieurs appels de la même page peuvent être refusés
  // ensemble et les empiler masquerait la page.
  private showForbidden(message: string) {
    if (this.dialog.openDialogs.some((ref) => ref.componentInstance instanceof DialogInfoComponent)) {
      return;
    }

    this.dialog.open(DialogInfoComponent, { data: { message } });
  }
}
